import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '../../../Globals';
import { HttpService } from '../../../services/http-service';
import { getSignupUserId, patchSignupProgress } from '../signup-user';

@Component({
  selector: 'app-payout-return',
  templateUrl: './payout-return.component.html',
  styleUrls: ['./payout-return.component.scss']
})
export class PayoutReturnComponent implements OnInit {
  globals = Globals;
  isLoadingResults = true;
  connectStatus: any = null;

  constructor(private service: HttpService, private router: Router) {}

  ngOnInit() {
    const userId = getSignupUserId();
    if (!userId) {
      this.service.showError('Please log in or continue registration.', 'ERROR');
      this.router.navigate(['/registration/registration-details']);
      return;
    }
    this.refreshStatus();
  }

  refreshStatus() {
    const userId = getSignupUserId();
    this.isLoadingResults = true;
    this.service.getRequest(this.globals.urls.signUp.noauth.connectStatus, {
      merchantId: userId,
      _id: userId
    }).subscribe(
      res => {
        this.isLoadingResults = false;
        if (res.success === 1 && res.data) {
          this.connectStatus = res.data;
          if (this.canProceed()) {
            try {
              localStorage.setItem('reg-payout-submitted', '1');
            } catch (e) {
              // ignore
            }
            patchSignupProgress({ signupStepCompleted: 2 });
          }
        }
      },
      () => {
        this.isLoadingResults = false;
      }
    );
  }

  canProceed(): boolean {
    if (!this.connectStatus) {
      return false;
    }
    if (this.connectStatus.payoutReady) {
      return true;
    }
    return !!(this.connectStatus.detailsSubmitted
      && this.connectStatus.connectStatus !== 'restricted');
  }

  continueToInsurance() {
    if (!this.canProceed()) {
      this.router.navigate(['/registration/payout-setup']);
      return;
    }
    this.router.navigate(['/registration/insurance-details']);
  }

  backToSetup() {
    this.router.navigate(['/registration/payout-setup']);
  }

  resultTitle(): string {
    if (this.isLoadingResults) {
      return 'Checking payout status…';
    }
    if (!this.connectStatus || !this.connectStatus.hasConnectedAccount) {
      return 'Payout setup incomplete';
    }
    if (this.connectStatus.payoutReady) {
      return 'Payouts enabled';
    }
    if (this.connectStatus.connectStatus === 'restricted') {
      return 'Action required';
    }
    if (this.connectStatus.detailsSubmitted) {
      return 'Details submitted';
    }
    return 'Continue setup';
  }

  resultBody(): string {
    if (this.isLoadingResults) {
      return 'Please wait while we confirm your status with Stripe.';
    }
    if (this.connectStatus && this.connectStatus.connectStatus === 'restricted') {
      return 'Stripe could not verify your payout details yet. Continue setup to fix any issues.';
    }
    if (this.canProceed()) {
      return 'You can continue with TCP & insurance. Stripe may still review your account in the background.';
    }
    return 'Please return to payout setup and complete all required fields on Stripe.';
  }
}
